// src/cms/video-upload/view/video-edit-dialog.jsx
import React from "react";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";

class VideoEditDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    var video = props.video || {};
    this.state = {
      title: video.title || "",
      description: video.description || "",
      brand: video.brand || "Entertainment",
      saving: false,
      error: "",
    };
    this.handleSave = this.handleSave.bind(this);
  }

  // --- helpers ---
  getAccessToken() {
    try {
      return localStorage.getItem("accessToken") || "";
    } catch (e) {
      return "";
    }
  }

  getDomainId() {
    var login = this.props && this.props.login ? this.props.login : null;
    if (!login || !login.user) return null;
    var ad = login.user.activeDomain || null;
    if (!ad) return null;
    return ad.domain_id || ad.domainId || ad.id || null;
  }

  getApiBase() {
    var base =
      typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_BLUE_SERVER
        ? process.env.REACT_APP_BLUE_SERVER
        : "";
    if (base && base.charAt(base.length - 1) === "/") base = base.slice(0, -1);
    return base;
  }
  // ---

  handleSave() {
    var title = (this.state.title || "").trim();
    if (!title) {
      this.setState({ error: "Title is required." });
      return;
    }

    var domainId = this.getDomainId();
    if (!domainId) domainId = 9704;

    var apiBase = this.getApiBase() || "http://localhost:4000";
    var accessToken = this.getAccessToken();
    var videoId = this.props.video && this.props.video.id;

    if (!videoId) {
      this.setState({ error: "Video ID is missing." });
      return;
    }

    var url =
      apiBase + "/article/" + String(domainId) + "/video/" + String(videoId);

    var self = this;
    this.setState({ saving: true, error: "" });

    axios
      .put(
        url,
        {
          title: title,
          description: (this.state.description || "").trim(),
          brand: this.state.brand,
        },
        {
          headers: {
            Authorization: accessToken || "",
            "Content-Type": "application/json",
          },
          timeout: 30000,
        }
      )
      .then(function () {
        self.setState({ saving: false });
        if (self.props.onSaved) {
          self.props.onSaved();
        }
      })
      .catch(function (err) {
        console.error("Failed to update video:", err);
        var msg = "Update failed.";
        try {
          if (err && err.response && err.response.data) {
            msg +=
              " " +
              (typeof err.response.data === "string"
                ? err.response.data
                : err.response.data.message || JSON.stringify(err.response.data));
          }
        } catch (e2) {}
        self.setState({ saving: false, error: msg });
      });
  }

  render() {
    var s = this.state;
    var props = this.props;

    return (
      <Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle style={{ paddingRight: 48 }}>
          Edit Video
          <IconButton
            onClick={props.onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={formStyle}>
            <label style={labelStyle}>
              Title<span style={{ color: "crimson" }}> *</span>
              <input
                type="text"
                value={s.title}
                onChange={function (e) {
                  this.setState({ title: e.target.value });
                }.bind(this)}
                placeholder="Enter title"
                style={inputStyle}
                disabled={s.saving}
              />
            </label>

            <label style={labelStyle}>
              Description
              <textarea
                value={s.description}
                onChange={function (e) {
                  this.setState({ description: e.target.value });
                }.bind(this)}
                placeholder="Enter short description"
                rows={4}
                style={{ ...inputStyle, resize: "vertical" }}
                disabled={s.saving}
              />
            </label>

            <label style={labelStyle}>
              Category
              <select
                value={s.brand}
                onChange={function (e) {
                  this.setState({ brand: e.target.value });
                }.bind(this)}
                style={inputStyle}
                disabled={s.saving}
              >
                <option value="Entertainment">Entertainment</option>
                <option value="News">News</option>
              </select>
            </label>

            {s.error ? <div style={errorStyle}>{s.error}</div> : null}
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button onClick={props.onClose} disabled={s.saving}>
            Cancel
          </Button>
          <Button
            onClick={this.handleSave}
            variant="contained"
            color="primary"
            disabled={s.saving}
          >
            {s.saving ? (
              <CircularProgress size={20} style={{ color: "white" }} />
            ) : (
              "Save Changes"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default VideoEditDialog;

// --- inline styles ---
var formStyle = { display: "grid", gap: 14 };

var labelStyle = {
  display: "grid",
  gap: 6,
  fontSize: 14,
  color: "#1f2328",
};

var inputStyle = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #d0d7de",
  fontSize: 14,
  outline: "none",
};

var errorStyle = {
  color: "crimson",
  background: "#fff0f0",
  border: "1px solid #ffd6d6",
  padding: "8px 10px",
  borderRadius: 8,
};
